import { isApiError } from '../api/errors';

export interface ErrorStateProps {
    error: unknown;
    onRetry?: () => void;
    title?: string;
}

/**
 * Foutmelding in gewone taal. Offline is hier expliciet géén fout: dan toont
 * de component een neutrale melding.
 */
export function ErrorState({ error, onRetry, title }: ErrorStateProps) {
    const offline = isApiError(error) && error.kind === 'offline';
    const message = isApiError(error)
        ? error.message
        : error instanceof Error
          ? error.message
          : 'Er ging iets mis.';

    return (
        <div
            role={offline ? 'status' : 'alert'}
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 'var(--space-8)',
                padding: 'var(--space-16)',
                borderRadius: 'var(--radius-control)',
                border: `1px solid ${offline ? 'var(--warn)' : 'var(--danger)'}`,
            }}
        >
            <strong>{title ?? (offline ? 'Geen verbinding' : 'Er ging iets mis')}</strong>
            <span style={{ color: 'var(--text-secondary)' }}>{message}</span>
            {onRetry ? (
                <button type="button" className="sk-touch-target" onClick={onRetry}>
                    Opnieuw proberen
                </button>
            ) : null}
        </div>
    );
}
